import type { FeatureHudPort } from "./FeatureHudPort";

/**
 * A `FeatureHudPort` whose real panel arrives later: the services (and their
 * `FeatureHudPresenter`) are built before the control bar that owns the HUD art. Calls before
 * `setTarget` are no-ops (nothing shows a feature before the bar exists).
 */
export class DeferredFeatureHudPort implements FeatureHudPort {
  private target: FeatureHudPort | null = null;

  public setTarget(target: FeatureHudPort | null): void {
    this.target = target;
  }

  public show(featureId: string, accumulatedWinText: string, spinsLeftText: string): void {
    this.target?.show(featureId, accumulatedWinText, spinsLeftText);
  }

  public hide(): void {
    this.target?.hide();
  }

  public setAccumulatedWinText(text: string): void {
    this.target?.setAccumulatedWinText(text);
  }

  public setSpinsLeftText(text: string): void {
    this.target?.setSpinsLeftText(text);
  }
}
